interface IOpenIdFlow {
  initialNextUrl: string;
  preAuthRequestState: string;
  preAuthResponseState: string;
  providerRequestState: string;
  providerResponseState: string;
  autoAuthenticate: string;
}

export const setOpenIdFlowSessionStorage = (key: keyof IOpenIdFlow, value: string): void => {
  sessionStorage.setItem(key, value);
};

export const getOpenIdFlowObject = (): IOpenIdFlow => {
  return {
    initialNextUrl: sessionStorage.getItem("initialNextUrl"),
    preAuthRequestState: sessionStorage.getItem("preAuthRequestState"),
    preAuthResponseState: sessionStorage.getItem("preAuthResponseState"),
    providerRequestState: sessionStorage.getItem("providerRequestState"),
    providerResponseState: sessionStorage.getItem("providerResponseState"),
    autoAuthenticate: sessionStorage.getItem("autoAuthenticate"),
  };
};
